import { render, staticRenderFns } from "./chatbot.vue?vue&type=template&id=80a143de&scoped=true"
import script from "./chatbot.vue?vue&type=script&lang=js"
export * from "./chatbot.vue?vue&type=script&lang=js"
import style0 from "./chatbot.vue?vue&type=style&index=0&id=80a143de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a143de",
  null
  
)

export default component.exports